import PageContainer from '@Guidelines/Layout/PageContainer';
import SubjectTypesNotifications from '@UI/Pages/Administration/SubjectTypes/Shared/SubjectTypesNotifications';
import SubjectTypeEditContent from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/SubjectTypeEditContent';
import type * as React from 'react';

/**
 * Assembles the editor screen for both routes: `/administration/subject-types/new` composes a new
 * type, `/administration/subject-types/:subjectTypeId` edits an existing one.
 */
const SubjectTypeEditPage: React.FC = () => {
	return (
		<PageContainer width="md">
			<SubjectTypeEditContent />
			<SubjectTypesNotifications />
		</PageContainer>
	);
};

export default SubjectTypeEditPage;
